import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles({
  label: {
    '& .MuiInputBase-input': {
      fontWeight: 'bold',
      color: '#5a6e74'
    },
  },
});

const InfoOt = (props) => {
  const { ot } = props;
  const classes = useStyles();
  const textFieldStyle = { width: isMobile ? '95%' : '75%', margin: '15px auto' };

  return (
    <div className="info-ot-container" style={{ height: isMobile ? '60vh' : '65vh' }}>
      <div className="row" style={{ overflow: 'auto', margin: '0' }}>
        <TextField className={classes.label} label="ID" value={ot.id} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="DATE DEBUT" value={ot.dateDeb ? moment(ot.dateDeb).format('DD/MM/YYYY à HH:mm:ss') : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="DESCRIPTION" value={ot.eqpDescription ? ot.eqpDescription : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="TYPE" value={ot.jobType ? ot.jobType : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="PRIORITE" value={ot.priorite?.libelle ? ot.priorite.libelle : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="DESCRIPTION" value={ot.jobDescription ? ot.jobDescription : '-'} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="STATUT" value={ot.userStatus ? ot.userStatus : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="SYMPTÔME" value={ot.symptome?.libelle ? ot.symptome.libelle : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="DÉFAUT" value={ot.defaut ? ot.defaut : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="CAUSE" value={ot.cause ? ot.cause : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="REMÈDE" value={ot.remede ? ot.remede : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
        <TextField className={classes.label} label="NB. HEURES" value={ot.nbHeure ? ot.nbHeure : ''} style={textFieldStyle} InputProps={{ readOnly: true, }} />
      </div>
    </div>
  );

};

export default InfoOt;